export const STATUS_COLORS = {
  very_ahead_of_pace: '#ec8a28',
  ahead_of_pace: '#f5cc6c',
  on_pace: '#00904f',
  behind_pace: '#e76161',
  very_behind_pace: '#dc3030'
}

export const PERFORMANCE_COLORS = {
  red: '#DF5347',
  green: '#009D4F',
  yellow: '#EC9628'
}

export const STATUS_TEXT_BY_KEY = {
  very_ahead_of_pace: 'Very ahead',
  ahead_of_pace: 'Ahead',
  on_pace: 'On pace',
  behind_pace: 'Behind',
  very_behind_pace: 'Very behind'
}

export const ZOOM_LEVELS = {
  all: 3.5,
  region: 5,
  sub_region: 6.5,
  division: 7.5
}

export const PACING_ZOOM_LEVEL = {
  all: 2.5,
  region: 3.3,
  sub_region: 4,
  division: 22
}

export const PACING_MAP_OFFSETS = {
  all: 40,
  region: 30,
  sub_region: 30,
  division: 0
}

export const LONGITUDE_DELTA = {
  all: 3,
  region: 1.5,
  sub_region: 1,
  division: 0.5
}

export const TIMEZONE = {
  'US/Eastern': 'America/New_York',
  'US/Central': 'America/Chicago',
  'US/Mountain': 'America/Denver',
  'US/Pacific': 'America/Los_Angeles'
}

export const TIMEZONE_VALUE = {
  'US/Eastern': 'ET',
  'US/Central': 'CT',
  'US/Mountain': 'MT',
  'US/Pacific': 'PT'
}

export const HTTP_STATUS_CODES = {
  OK: 200,
  REQUEST_TIMEOUT: 408
}

export const ISC_METRICS = {
  response_time_assigned_to_contact: 'ISC assigned to outreach <2m',
  response_time_queue_to_assigned: 'Queue to ISC assigned <30s',
  quality: 'ISC Quality Score over 4'
}

export const LENNAR_LIVE_URL = 'https://sales-machine.lennar.com'
